/* BetterWithClara · Boundaries landing page behaviour (FAQ one-open-at-a-time + sticky buy bar).
   Re-runs when a section is edited in the Theme Editor. */
(function () {
  var buybarObservers = [];

  function initFaq() {
    var items = [].slice.call(document.querySelectorAll('.bwc-faq__item'));
    items.forEach(function (item) {
      if (item.dataset.bwcFaq) return;
      item.dataset.bwcFaq = '1';
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        document.querySelectorAll('.bwc-faq__item').forEach(function (other) {
          if (other !== item && other.open) other.open = false;
        });
      });
    });
  }

  /* Sticky buy bar: show once the page's first section (normally the Hero) has scrolled away;
     hide while an in-page buy button or the footer is visible. Works whichever sections are shown. */
  function initBuybar() {
    buybarObservers.forEach(function (o) { o.disconnect(); });
    buybarObservers = [];
    var bar = document.querySelector('.bwc-buybar');
    var main = document.getElementById('MainContent') || document.body;
    var hero = bar && [].slice.call(main.children).filter(function (el) { return !el.contains(bar) && el.offsetHeight > 0; })[0];
    if (!bar || !hero || !('IntersectionObserver' in window)) return;
    var barBtn = bar.querySelector('.bwc-btn');
    var blockers = [].slice.call(document.querySelectorAll('.bwc-btn, .bwc-footer')).filter(function (el) { return !bar.contains(el); });
    var pastHero = false, blocked = new Set();
    function update() {
      var show = pastHero && blocked.size === 0;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (barBtn) barBtn.tabIndex = show ? 0 : -1;
    }
    var heroObs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { pastHero = !e.isIntersecting && e.boundingClientRect.top < 0; });
      update();
    });
    heroObs.observe(hero);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) blocked.add(e.target); else blocked.delete(e.target); });
      update();
    });
    blockers.forEach(function (el) { io.observe(el); });
    buybarObservers.push(heroObs, io);
  }

  function init() { initFaq(); initBuybar(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', function () { setTimeout(initBuybar, 0); });
})();
